import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=205ee3cb&scoped=true&"
import script from "./page-footer.vue?vue&type=script&lang=js&"
export * from "./page-footer.vue?vue&type=script&lang=js&"
import style0 from "./page-footer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./page-footer.vue?vue&type=style&index=1&id=205ee3cb&lang=less&scoped=true&"
import style2 from "./page-footer.vue?vue&type=style&index=2&id=205ee3cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ee3cb",
  null
  
)

export default component.exports